export default __webpack_public_path__ + "static/media/closet5-before1-1440w.082559e4.webp";